import CardDesign from "./CardDesign";
import {useEffect, useState} from "react";
import {getCardInfo} from "../../api/cash/cash.api";


const RefundForm = ({creditType, availableCredit, cardId, refundCredit, refundAmount}) => {
    const [cardInfo, setCardInfo] = useState({})

    useEffect(() => {
        getCardInfo(cardId).then(({data}) => {
            // 카드가 그 사이 삭제됐거나 조회에 실패하면 data 가 null 로 온다.
            // 빈 객체로 두면 카드 디자인이 마스킹 자리표시자로 그려진다(널 참조로 화면이 죽지 않는다).
            setCardInfo(data ?? {})
        })
    }, [cardId]);

    return (
        <>
            <div className="font-bold text-[20px] mb-2">환불될 카드</div>
            {/* 환불될 카드를 '보여주기만' 하는 자리 — 기본카드 변경·삭제 버튼이 뜨면 안 된다. */}
            <div className="font-medium text-[16px]"><CardDesign cardInfo={cardInfo} readOnly /></div>
            <div className="w-full flex-col items-end">
                {
                    creditType === "AI" && (
                        <label className="font-medium text-[16px]">
                            환불 크레딧: {refundCredit.toLocaleString()} Credit
                        </label>
                    )
                }
                {
                    availableCredit < refundCredit && (
                        <div className="text-red-500 text-[16px]">잔액 부족으로 환불할 수 없습니다.</div>
                    )
                }
                <label className="font-medium text-[18px] text-primary">
                    총 환불 금액: {refundAmount.toLocaleString()}원 KRW
                </label>
            </div>
        </>
    )
}

export default RefundForm